import LedDiagram from "../../../../docs/_images/hw_ff_led.png";
import LedSchematics from "../../../../docs/_images/hw_ff_led_schem.png";
import * as React from 'react';
export default {
  LedDiagram,
  LedSchematics,
  React
};